let cities = require('../../actions/custom-order/cities');
let { isTabSelected } = require('../../actions/custom-order/index');
let { calcPriceGroup } = require('../groups/order');
let analytics = require('../../actions/analytics');
let utils = require('../../actions/utils');

module.exports = {
    onItemCheck: [
        cities.changeValue,
        utils.setArg('category', 'checkbox_geo'),
        [
            analytics.fillEventFromTreeChecked,
            {
                filled: [analytics.raiseArgsValueEvent],
                noEvent: []
            }
        ],
        ...calcPriceGroup
    ],

    onBranchCheck: [
        cities.changeBranchSelection,
        utils.setArg('category', 'select_branch'),
        utils.setArg('action', 'click'),
        [
            analytics.fillEvent,
            {
                filled: [analytics.raiseArgsValueEvent],
                noEvent: []
            }
        ],
        ...calcPriceGroup
    ],

    onSetAll: [
        cities.setAll,
        ...calcPriceGroup
    ],

    toggleMapFilter: [
        [
            isTabSelected('map'),
            {
                yes: [
                    cities.localSaveMapFilter,
                    utils.unset(['order', 'cities', 'tab'])
                ],
                no: [
                    utils.set(['order', 'cities', 'tab'], 'map'),
                    utils.setArg('category', 'tab_filter_map'),
                    utils.setArg('action', 'click'),
                    analytics.raiseArgsValueEvent
                ]
            }
        ],
        ...calcPriceGroup
    ],

    toggleFilterType: [
        cities.toggleFilterType
    ]
};



// WEBPACK FOOTER //
// ./signals/custom-order/cities.js